var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.showMenu)?_c('bp-header'):_vm._e(),_c('div',{staticClass:"menu-container"},[(this.showMenu)?_c('sidebar-menu',{attrs:{"collapsed":_vm.collapsed,"width":"420px","menu":_vm.menu}}):_vm._e()],1),_c('router-view',{key:_vm.$route.fullPath,attrs:{"tables":_vm.visibleTables}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }